export class ContactService {
  sendContact(data: any) { }
}
